// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"967":"a998333a","4909":"6a0d5a71","7255":"10d6299b","9973":"758f106b"}[chunkId] || chunkId) + "." + {"967":"32ef0b1bf3eb23b4","4909":"ca959d9bcd2add96","6617":"fa65e783d9406ec2","7255":"b820c0b6fa306c43","9973":"e6dfb3036deab4fe"}[chunkId] + ".js";
};